import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'

export const gmailIntegration: PreviewIntegration = {
  id: 'gmail',
  name: 'Gmail',
  description: 'Integrate your email content from Gmail into Go as context for AI.',
  icon: 'gmail-logo',
}
